import React from 'react';

import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';
import Button from '../../components/Button';
import * as T from '../../components/Typography';
import GraphicBurst from '../../components/GraphicBurst';
// ! TODO: ADD Button links once provided by client
// import { navRoutes } from '../../constants';

import { dataEarn, dataSpend } from './data';
import { navRoutes } from '../../constants';

const WaysEarnSpendSection = ({ type }) => {
  return (
    <SectionLayout>
      <Row>
        <Col w={[4, 6, 7]}>
          <T.H4Bold color="midnight">
            Examples of ways people {type === 'earn' ? 'earn' : 'spend'} Time Credits include:
          </T.H4Bold>
        </Col>
      </Row>
      <Row mb={4}>
        {type === 'earn'
          ? dataEarn.map(i => (
              <Col w={[4, 3, 4]} mt={5}>
                <GraphicBurst image={i.image} title={i.title} />
              </Col>
            ))
          : dataSpend.map(i => (
              <Col w={[4, 3, 4]} mt={5}>
                <GraphicBurst image={i.image} title={i.title} />
              </Col>
            ))}
      </Row>
      <Row>
        <Col w={[4, 3, 4]}>
          <Button color="blue" small external to={navRoutes.tempoWebsite} caps={false}>
            Explore {type === 'earn' ? 'earn' : 'spend'} activities
          </Button>
        </Col>
      </Row>
    </SectionLayout>
  );
};

export default WaysEarnSpendSection;
